import { createEntityAdapter } from "@reduxjs/toolkit";
import apiSlice from "../api/apiSlice";
import { effectiveAtQuery } from "../../utils/businessValidity";

const respAdapter = createEntityAdapter({});

const initialState = respAdapter.getInitialState({});

export const respApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllRespByCommunityId: builder.query({
      query: (argument) => {
        const communityId = typeof argument === "string" ? argument : argument.communityId;
        const effectiveAt = typeof argument === "string" ? undefined : argument.effectiveAt;
        return {
          url: `/communities/${communityId}/resp?${effectiveAtQuery(effectiveAt)}`,
          method: "GET",
        };
      },
      transformResponse: (responseData) => {
        if (responseData) {
          responseData = responseData.map((item) => ({ id: item.resp_id, ...item }));
          return respAdapter.setAll(initialState, responseData);
        }
        return respAdapter.setAll(initialState, []);
      },
      providesTags: [{ type: "RESP", id: "LIST" }],
    }),
    updateRespById: builder.mutation({
      query: ({ assetId, communityId, newAsset, effectiveAt }) => ({
        url: `/communities/${communityId}/resp/${assetId}?${effectiveAtQuery(
          effectiveAt ?? newAsset?.start_date
        )}${newAsset?.end_date ? `&end_date=${encodeURIComponent(newAsset.end_date)}` : ""}`,
        method: "PUT",
        body: {
          ...newAsset,
        },
      }),
      invalidatesTags: [{ type: "RESP", id: "LIST" }],
    }),
  }),
});

export const { useGetAllRespByCommunityIdQuery, useUpdateRespByIdMutation } = respApiSlice;
